import NotFound from 'components/NotFound';
import Staff from 'components/Staff/Staff';
import Settings from 'components/practice/Settings/Settings';
import Account from 'components/practice/Settings/components/Account/Account';
import BillingSettings from 'components/practice/Settings/components/Billing/Billing';
import CalendarSettings from 'components/practice/Settings/components/Calendar/Calendar';
import EPrescribeSettings from 'components/practice/Settings/components/EPrescribe/EPrescribe';
import FormBuilder from 'components/practice/Settings/components/Forms/FormBuilder/FormBuilder';
import FormPackets from 'components/practice/Settings/components/Forms/FormPackets/FormPackets';
import Forms from 'components/practice/Settings/components/Forms/Forms';
import KioskSettings from 'components/practice/Settings/components/Kiosks/KioskSettings';
import Packages from 'components/practice/Settings/components/Packages/Packages';
import Payers from 'components/practice/Settings/components/Payers/Payers';
import Products from 'components/practice/Settings/components/Products/Products';
import Resources from 'components/practice/Settings/components/Resources/Resources';
import Services from 'components/practice/Settings/components/Services/Service';
import Tags from 'components/practice/Settings/components/Tags/Tags';
import Roles from 'components/shared/Roles-new/Roles';

const PRACTICE_SETTINGS = [
  {
    path: 'settings',
    element: <Settings />,
    children: [
      {
        path: 'services',
        element: <Services />
      },
      {
        path: 'products',
        element: <Products />
      },
      {
        path: 'packages',
        element: <Packages />
      },
      {
        path: 'calendar',
        element: <CalendarSettings />
      },
      {
        path: 'forms',
        element: <Forms />,
        children: [
          { path: '', element: <FormBuilder /> },
          { path: 'form-packets', element: <FormPackets /> }
        ]
      },
      {
        path: 'payers',
        element: <Payers />
      },
      {
        path: 'account',
        element: <Account />
      },
      {
        path: 'staff',
        element: <Staff />
      },
      {
        path: 'roles',
        element: <Roles />
      },
      {
        path: 'eprescribe',
        element: <EPrescribeSettings />
      },
      {
        path: 'billing',
        element: <BillingSettings />
      },
      {
        path: 'kiosk',
        element: <KioskSettings />
      },
      {
        path: 'resources',
        element: <Resources />
      },
      {
        path: 'tags',
        element: <Tags />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  }
];

export default PRACTICE_SETTINGS;
